app.controller('BankIdSettingsCtrl', ['$scope', '$controller', 'server', 'alertProvider', function ($scope, $controller, server, alertProvider) {
        $controller('AddCtrl', { $scope: $scope });
        $scope.fields = [
            { name: 'certfile', title: 'Upload certificate', type: 'file' }
        ];
        $scope.submit = function () {
            server.postFile('/api/settings/bankid/set', $scope.fields[0].value).then(function (response) {
                if (response.success)
                    alertProvider.show('success', 'Success');
                else
                    alertProvider.show('error', 'Failed');
            })["catch"](function () {
                alertProvider.show('error', 'Failed');
            });
        };
    }]);
